import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Link, Typography } from "@mui/material";
import { useOcProperty } from "oc/hooks";

export const MyHrHelpdeskContact = () => {
  const { t } = useTranslation();

  const { data: helpdeskEmail } = useOcProperty({
    resource: "system",
    key: "helpdeskEmail",
  });

  const { data: helpdeskPhone } = useOcProperty({
    resource: "system",
    key: "helpdeskPhone",
  });

  const { data: helpdeskURL } = useOcProperty({
    resource: "system",
    key: "helpdeskURL",
  });

  const { data: helpdeskCustomText } = useOcProperty({
    resource: "system",
    key: "helpdeskCustomText",
  });

  let mailto = `mailto:${helpdeskEmail}`;

  let tel = `tel:${"+36" + helpdeskPhone}`;

  return (
    <Box padding="0px 48px" style={{ lineBreak: "auto" }}>
      <Typography variant="body1" style={{ color: "#5E6366" }}>
        {helpdeskCustomText?.length === 0 ||
        helpdeskCustomText === null ||
        helpdeskCustomText === ""
          ? t("MY_HR_HELPDESK_CONTACTS_INFO")
          : helpdeskCustomText}
      </Typography>
      <Box height="4px" />
      {helpdeskPhone?.length !== undefined && helpdeskPhone?.length !== 0 && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="body1" style={{ color: "#5E6366" }}>
            {t("MY_HR_PHONE")}:
          </Typography>
          <Box width="5px" />
          <Link
            style={{ cursor: "pointer", fontSize: "16px" }}
            href="#"
            onClick={(e) => {
              window.location.href = tel;
              e.preventDefault();
            }}
          >
            {"+36 " + helpdeskPhone || ""}
          </Link>
        </Box>
      )}
      <Box height="4px" />
      {helpdeskURL?.length !== undefined && helpdeskURL?.length !== 0 && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Box width="5px" />
          <Link
            href={"https://" + helpdeskURL}
            target="_blank"
            rel="noreferrer"
          >
            {helpdeskURL || ""}
          </Link>
        </Box>
      )}
      <Box height="4px" />
      {helpdeskEmail?.length !== undefined && helpdeskEmail?.length !== 0 && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="body1" style={{ color: "#5E6366" }}>
            {t("MY_HR_EMAIL")}:
          </Typography>
          <Box width="5px" />
          <Link
            style={{
              cursor: "pointer",
              fontSize: "16px",
              color: "#CC0033",
              textDecoration: "none",
            }}
            href="#"
            onClick={(e) => {
              window.location.href = mailto;
              e.preventDefault();
            }}
          >
            {helpdeskEmail || ""}
          </Link>
        </Box>
      )}{" "}
    </Box>
  );
};

export default MyHrHelpdeskContact;
